export default __webpack_public_path__ + "static/behavioral-cohorts-light-mode-c1c996573ddb11c6ec656feda256bdec.png";